import { PRICE_STATUS } from '../components/contexts/price-context/PRICE_STATUS'
import { IToggleStatus } from '../components/contexts/price-context/PriceContext'
import { VAT_STATUS } from '../components/contexts/price-context/VAT_STATUS'
import { ComputedPrice, PriceObjectOutputDto } from '../lib/graphql'

export const getPriceFromToggleStatus = ({
  priceOption,
  toggleStatus,
  discountPrices = false,
  total = false,
}: {
  priceOption?: PriceObjectOutputDto | null
  toggleStatus: IToggleStatus
  discountPrices?: boolean
  total?: boolean
}): number => {
  let priceType: {
    user: keyof PriceObjectOutputDto
    owner: keyof PriceObjectOutputDto
  } = {
    user: 'priceWithUserFees',
    owner: 'basePrice',
  }

  if (discountPrices || total) {
    priceType = {
      user: 'priceWithDiscountAndFees',
      owner: 'priceWithDiscount',
    }
  }

  if (!priceOption) {
    return 0
  }

  const price = (
    toggleStatus.priceStatus === PRICE_STATUS.USER
      ? priceOption[priceType.user]
      : priceOption[priceType.owner]
  ) as ComputedPrice

  return (
    (toggleStatus.vatStatus === VAT_STATUS.HT
      ? price?.priceWithoutVat
      : price?.priceWithVat) ?? 0
  )
}
